import { authClient, API } from '../index'

export const getContactFormMessagesAdmin = (params) => {
  const search = new URLSearchParams()
  if (params?.limit) search.set('limit', String(params.limit))
  if (params?.readStatus) search.set('readStatus', String(params.readStatus))
  if (params?.replyStatus) search.set('replyStatus', String(params.replyStatus))
  if (params?.emailQ) search.set('emailQ', String(params.emailQ))
  const q = search.toString()
  return authClient().get(`${API}/contact-form/admin${q ? `?${q}` : ''}`)
}

export const getContactFormMessageAdmin = (id) => {
  return authClient().get(`${API}/contact-form/admin/${id}`)
}

export const markContactFormMessageRead = (id) => {
  return authClient().patch(`${API}/contact-form/${id}/read`)
}

export const replyContactFormMessage = (id, payload) => {
  return authClient().post(`${API}/contact-form/${id}/reply`, payload)
}
